import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { selectToken } from '../store/query-params';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  accessToken!: string;

  constructor(private store: Store<any>) {
    this.store.select(selectToken).subscribe((token) => {
      this.accessToken = token!;
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isHtml = this.isHtml(req.url);
    const isImage = this.isImage(req.url);

    const accept = isImage
      ? 'image/png'
      : isHtml
      ? 'text/html'
      : 'application/json';

    req = req.clone({
      headers: req.headers.append('Accept', accept),
    });

    req = req.clone({
      headers: req.headers.append(
        'Authorization',
        `Bearer ${this.accessToken}`
      ),
    });

    // req = req.clone({
    //   headers: req.headers.append(
    //     'X-MG-ClientRequestId',
    //     uuidv4()
    //   )
    // });

    if (isImage) {
      req = req.clone({
        responseType: 'blob',
      });
    } else if (isHtml) {
      req = req.clone({
        responseType: 'text',
      });
    }

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.error !== undefined) {
          if (err.error.error !== undefined) {
            return throwError({
              ...err.error.error,
              responseRaw: err.error,
            });
          } else {
            return throwError({
              ...err.error,
              responseRaw: err,
            });
          }
        }
        return throwError(err);
      })
    );
  }

  private isHtml(url: string): boolean {
    return ['receipt', 'inAppNotification', 'unplannedError'].some((u) => {
      return url.indexOf(u) > -1;
    });
  }

  private isImage(url: string): boolean {
    return ['qrCode'].some((u) => {
      return url.indexOf(u) > -1;
    });
  }

  // private generateUUID(maxLength: number = 16) {
  //   let generatedUUID = ''
  //   while(generatedUUID.length < maxLength) {
  //     generatedUUID += Math.random().toString(16).substring(2); // substring 2 is used to remove '0.' from amth.random
  //   }
  //   return generatedUUID.substring(0, maxLength);
  // }
}
